import {
  getUserFreebiesDetail,
  postUserFreebiesReward,
  getRouletteRewards,
} from '~/api/agent-retention';
import { postClaimVoucher } from '~/api/promos';

  export const state = () => ({
    hasPlayed: 'not_played',
    freebiesReward: {
      type: 'zonk',
      detail: null,
      rouletteIndex: 2,
      title: null,
      subtitle: null,
      category: 'zonk',
    },
    freebiesRoulettePrizeIndex: {
      phone_credit_prepaid: 0,
      digital_voucher: 1,
    },
    rouletteRewards: [],
  });
  
  export const getters = {
    hasPlayedFreebies: state => !!state.hasPlayed && (['ineligible', 'has_played'].includes(state.hasPlayed)),
    getFreebiesReward: state => state.freebiesReward,
    getRouletteRewards: state => state.rouletteRewards,
  };

  export const mutations = {
    setPlayFreebiesState(state, playState) {
      state.hasPlayed = playState;
    },
    setUserFreebiesState(state, { reward, state: responseState, reward_detail: rewardDetail, title, subtitle, icon_url: iconURL, category, redirect_link: redirectLink }) {
      state.hasPlayed = responseState;

      // roulette index = 2 means zonk
      state.freebiesReward = {
        ...state.freebiesReward,
        type: reward,
        detail: rewardDetail,
        rouletteIndex: reward === 'zonk' || responseState === 'ineligible' ? 2 : state.freebiesRoulettePrizeIndex[category] || 0,
        iconURL,
        category,
        redirectLink,
      };

      if (title !== null) state.freebiesReward.title = title;
      if (subtitle !== null) state.freebiesReward.subtitle = subtitle;
    },
    setFreebiesRewardDetail(state, voucherCode) {
      state.freebiesReward.detail.voucher_code = voucherCode;
    },
    setVoucherFreebiesRewardCopy(state, neoText) {
      const { default_text: defaultText, title_text: titleText } = neoText;
      if (defaultText) state.freebiesReward.subtitle = defaultText;
      if (titleText) state.freebiesReward.title = titleText;
    },
    setRouletteRewards(state, rouletteRewards) {
      state.rouletteRewards = rouletteRewards;
    }
  };
  
  export const actions = {
    setVoucherFreebiesRewardCopy({ commit }, text) {
      commit('setVoucherFreebiesRewardCopy', text);
    },
    async fetchUserFreebiesState({ commit, dispatch }, userId) {
      try {
        const response = await getUserFreebiesDetail(this.$axios, userId);
        const { data } = response;

        commit('setUserFreebiesState', data);
        return response;
      } catch (error) {
        dispatch('flashalert/showFlashAlert', { message: 'Sedang ada gangguan, Silahkan main beberapa saat lagi', type: 'warning' }, { root: true });
      }
    },
    async postUserFreebiesState({ commit, dispatch }) {
      try {
        const response = await postUserFreebiesReward(this.$axios);
        const { data } = response;

        commit('setUserFreebiesState', data);
        return response;
      } catch (error) {
        dispatch('flashalert/showFlashAlert', { message: 'Sedang ada gangguan, Silahkan main beberapa saat lagi', type: 'warning' }, { root: true });
      }
    },
    async postClaimVoucher({ commit, dispatch, rootGetters }) {
      let response = {
        data: null,
      };
      try {
        response = await postClaimVoucher(this.$axios);
        const { data } = response;
        const userId = rootGetters['auth/getUserId'];

        if (data.voucher_code) commit('setFreebiesRewardDetail', data.voucher_code);
        dispatch('fetchUserFreebiesState', userId);
        return response;
      } catch (error) {
        dispatch('flashalert/showFlashAlert', { message: 'Sedang ada gangguan, Silahkan main beberapa saat lagi', type: 'warning' }, { root: true });
      }
      return response;
    },
    async fetchRouletteRewards({ commit, dispatch }) {
      try {
        const response = await getRouletteRewards(this.$axios);
        const { data } = response;
        
        commit('setRouletteRewards', data);
        return response;
      } catch (error) {
        dispatch('flashalert/showFlashAlert', { message: 'Sedang ada gangguan, Silahkan main beberapa saat lagi', type: 'warning' }, { root: true });
      }
    },
  };
